import { User as SupabaseUser } from '@supabase/supabase-js';

export interface User {
  id: string;
  email: string;
  emailConfirmed: boolean;
  createdAt: string;
}

export interface UserProfile {
  id: string;
  email: string;
  fullName?: string;
  company?: string;
  createdAt: string;
}

export function mapSupabaseUser(user: SupabaseUser | null): User | null {
  if (!user) return null;
  
  return {
    id: user.id,
    email: user.email || '',
    emailConfirmed: user.email_confirmed_at !== null,
    createdAt: user.created_at || new Date().toISOString(),
  };
}
